<template>
  <b-row>
    <b-col cols="12">
      <employee-leave-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmployeeLeaveEditForm from './EmployeeLeaveEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    EmployeeLeaveEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
